import React, {useRef} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Button, Text} from '@chakra-ui/react3'
import {Gift2Icon} from '../../../../../leap/components/icons'
import {useAddGiftToBabylist} from '../../../../../babylist-api'

const BabyListBtn = ({product, showLabel = true, onClick, ...props}) => {
    const babyListBtnRef = useRef(null)
    const {formatMessage} = useIntl()
    const babyListLabel = formatMessage({
        id: 'product_detail.link.add_to_babylist',
        defaultMessage: 'Add to Babylist'
    })
    const {enabled, execute, loading} = useAddGiftToBabylist(product, babyListBtnRef)

    if (!enabled) {
        return null
    }

    return (
        <Button
            ref={babyListBtnRef}
            size="lg"
            variant="primaryFilled"
            bg="partner.baby-list"
            _hover={{bg: 'partner.baby-list', filter: 'brightness(0.9)'}}
            onClick={(e) => {
                onClick?.(e)
                execute()
            }}
            aria-label={babyListLabel}
            isDisabled={loading}
            {...props}
        >
            {showLabel && <Text>{babyListLabel}</Text>}
            <Gift2Icon />
        </Button>
    )
}

BabyListBtn.propTypes = {
    showLabel: PropTypes.bool,
    product: PropTypes.object,
    onClick: PropTypes.func
}

export default BabyListBtn
